import React, { useState, useEffect, useRef } from "react";
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";
import DevelopersLogin from "../../assets/images/developers_login.png";
import DevelopersSmsOtp from "../../assets/images/developers_sms_otp.png";
import DevelopersHamburgerMenu from "../../assets/images/developers_hamburger_menu.png";
import ResourceDownloadsSidebar from "../../assets/images/resource_downloads_sidebar.png";
import NetsQrCrossBorderApps from "../../assets/images/nets_qr_cross_border_apps.png";
import DevelopersSandbox from "../../assets/images/developers_sandbox.png";
import SandboxProjectDetails from "../../assets/images/sandbox_project_details.png";
import SandboxProject from "../../assets/images/sandbox_project.png";
import ResourcePolyFinTechPaytechNetsQr from "../../assets/images/resource_polyfintech_paytech_nets_qr.png";
import CertificationTabSandboxNetsQrMobile from "../../assets/images/certification_tab_sandbox_nets_qr_mobile.png";
import CertificationTabSandboxNetsQrWeb from "../../assets/images/certification_tab_sandbox_nets_qr_web.png";
import SandboxCourseCertificate from "../../assets/images/sandbox_course_certificate.png";
import SandboxCourseCertificateDetails from "../../assets/images/sandbox_course_certificate_details.png";

const NetsQrIdeationLayout = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  // Add state for image modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imageSrc: ""
  });

  // Function to open image modal
  const openImageModal = (imageSrc) => {
    setImageModal({
      isOpen: true,
      imageSrc: imageSrc
    });
  };
  
  // Function to close image modal
  const closeImageModal = () => {
    setImageModal({
      isOpen: false,
      imageSrc: ""
    });
  };
  
  // Create refs for each step section - UPDATED: Now 5 steps
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);

  // Setup intersection observer to detect which step is in view - UPDATED: 5 steps
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "-100px 0px -60% 0px", // Adjust these values as needed
      threshold: 0
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const stepId = parseInt(entry.target.getAttribute('data-step'));
          setActiveStep(stepId);
        }
      });
    }, options);
    
    // Observe all step elements - UPDATED: 5 steps
    if (step1Ref.current) observer.observe(step1Ref.current);
    if (step2Ref.current) observer.observe(step2Ref.current);
    if (step3Ref.current) observer.observe(step3Ref.current);
    if (step4Ref.current) observer.observe(step4Ref.current);
    if (step5Ref.current) observer.observe(step5Ref.current);

    return () => {
      // Clean up observer on component unmount - UPDATED: 5 steps
      if (step1Ref.current) observer.unobserve(step1Ref.current);
      if (step2Ref.current) observer.unobserve(step2Ref.current);
      if (step3Ref.current) observer.unobserve(step3Ref.current);
      if (step4Ref.current) observer.unobserve(step4Ref.current);
      if (step5Ref.current) observer.unobserve(step5Ref.current);
    };
  }, []);

  // Scroll to specific step when clicking on sidebar links
  const scrollToStep = (stepId) => {
    const element = document.getElementById(`step${stepId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile sidebar when selecting a step
    setShowMobileSidebar(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header/>

      {/* Image Modal */}
      {imageModal.isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeImageModal}
        >
          <div className="relative max-w-[90vw] max-h-[90vh]">
            <button 
              className="absolute top-2 right-2 bg-white rounded-full p-2 text-gray-800 hover:text-gray-600 focus:outline-none"
              onClick={closeImageModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={imageModal.imageSrc} 
              alt="Enlarged view"
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on the image itself
            />
          </div>
        </div>
      )}

      {/* Sticky Breadcrumb - shortened for mobile */}
      <div className="sticky top-0 z-10 bg-gray-100 py-2 sm:py-3 shadow-md">
        <div className="container mx-auto px-4 sm:px-6">
          <p className="text-xs sm:text-sm text-gray-600 text-left truncate">
            <a href="/competition" className="text-blue-600 hover:underline"> Competition</a> &gt; 
            <span className="hidden sm:inline"> NETS QR Payment Gateway </span>
            <span className="inline sm:hidden"> NETS QR</span> 
          </p>
        </div>
      </div>

      {/* Mobile Step Navigator - only visible on mobile - UPDATED: Now shows 5 steps */}
      <div className="md:hidden sticky top-10 z-10 bg-white shadow-md py-2 px-4">
        <div className="flex justify-between items-center">
          <div className="text-sm font-medium">
            Step {activeStep} of 5
          </div>
          <button 
            onClick={() => setShowMobileSidebar(!showMobileSidebar)}
            className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm"
          >
            {showMobileSidebar ? 'Hide Steps' : 'Show Steps'}
          </button>
        </div>
        
        {/* Mobile Sidebar - collapsible - UPDATED: Now 5 steps */}
        {showMobileSidebar && (
          <div className="mt-3 pb-2 border-t pt-2">
            <ul className="space-y-3 text-sm">
              {[1, 2, 3, 4, 5].map(step => (
                <li 
                  key={step}
                  className={`${activeStep === step ? "text-blue-600 font-medium" : "text-gray-700"} 
                    text-left transition-colors duration-300 cursor-pointer hover:text-blue-500
                    py-1`}
                  onClick={() => scrollToStep(step)}
                >
                  Step {step} | {step === 1 ? "Setup account" :
                                 step === 2 ? "Create project" :
                                 step === 3 ? "Download resources" :
                                 step === 4 ? "Start ideation" :
                                             "Get certified"}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Main Content - responsive grid */}
      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-12 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 text-left flex-grow">
        {/* Sidebar - hidden on mobile - UPDATED: Now 5 steps */}
        <aside className="hidden md:block bg-white rounded-lg shadow-md p-4 sm:p-6 text-left md:sticky md:top-16 self-start">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">In this Tutorial</h3>
          <ul className="space-y-4 text-sm text-left">
            <li 
              className={`${activeStep === 1 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(1)}
            >
              Step 1 | Setup OPENAPIPASS developer account
            </li>
            <li 
              className={`${activeStep === 2 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(2)}
            >
              Step 2 | Create your NETS QR project
            </li>
            <li 
              className={`${activeStep === 3 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(3)}
            >
              Step 3 | Download NETS QR resources
            </li>
            <li 
              className={`${activeStep === 4 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(4)}
            >
              Step 4 | Start your NETS QR ideation
            </li>
            <li 
              className={`${activeStep === 5 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(5)}
            >
              Step 5 | Get certified in NETS QR
            </li>
          </ul>
        </aside>
        
        {/* Main Section - takes full width on mobile */}
        <section className="col-span-1 md:col-span-2 text-left">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 text-left">NETS QR Payment Gateway Ideation</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
            Follow the steps below to start your NETS QR payment gateway ideation journey for PolyFinTech100 API Hackathon!
          </p>

          {/* Step 1 */}
          <div id="step1" ref={step1Ref} data-step="1" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 1 | Setup OPENAPIPASS developer account</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Go to the website <a href="https://developers.openapipass.org/homepage" className="text-blue-600 hover:underline break-all">https://developers.openapipass.org/homepage</a> to log in to your developer account by entering your phone number. Click on 'Get SMS OTP'. On receiving the SMS OTP, click on 'Proceed' button.
            </p>
            
            <div className="flex flex-col items-center sm:items-start space-y-4 mb-4 sm:mb-6">
              <img
                src={DevelopersLogin}
                alt="OPENAPIPASS Login Page"
                className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersLogin)}
              />
              <img
                src={DevelopersSmsOtp}
                alt="OPENAPIPASS OTP Verification"
                className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersSmsOtp)}
              />
            </div>
          </div>
          
          {/* Step 2 */}
          <div id="step2" ref={step2Ref} data-step="2" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 2 | Create your NETS QR sandbox project</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once logged in, navigate to the Sandbox environment and create a new project for NETS QR payment gateway integration. This will be your testing environment for developing innovative payment solutions.
            </p>
            <img
              src={DevelopersSandbox}
              alt="Sandbox Environment Selection"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(DevelopersSandbox)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Fill in the details like in the image below.
            </p>
            <img
              src={SandboxProjectDetails}
              alt="Industry Selection"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(SandboxProjectDetails)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Here, you would see that your sandbox project created, click on it to view your sandbox credentials.
            </p>
            <img
              src={SandboxProject}
              alt="Project Details Form"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(SandboxProject)}
            />
          </div>

          {/* Step 3 */}
          <div id="step3" ref={step3Ref} data-step="3" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 3 | Download NETS QR resources and documentation</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on the menu icon at the top left corner of the webpage to access the resources section.
            </p>
            <img
              src={DevelopersHamburgerMenu}
              alt="OPENAPIPASS Menu"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(DevelopersHamburgerMenu)}
            />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Navigate to 'Resources' &gt; 'Downloads' &gt; 'PolyFinTech' &gt; 'PayTech' to download your respective NETS QR Resources. <br /> (If your project is on Mobile, download NETS QR Mobile. If your project is on Web, download NETS QR Web.)
            </p>
            <img
              src={ResourceDownloadsSidebar}
              alt="Downloads Section"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(ResourceDownloadsSidebar)}
            />
            <img
              src={ResourcePolyFinTechPaytechNetsQr}
              alt="NETS QR Download Resources"
              className="shadow-md rounded-md w-full max-w-lg cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourcePolyFinTechPaytechNetsQr)}
            />
          </div>

          {/* Step 4 */}
          <div id="step4" ref={step4Ref} data-step="4" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 4 | Start your NETS QR ideation journey</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Create your own mock data for the competition with integrated NETS Payment Gateway.
            </p>

            <img
              src={NetsQrCrossBorderApps}
              alt="NETS QR Payment Flow"
              className="shadow-md rounded-md w-full max-w-sm cursor-pointer hover:opacity-90 transition-opacity mb-4"
              onClick={() => openImageModal(NetsQrCrossBorderApps)}
            />
          </div>

          {/* Step 5 */}
          <div id="step5" ref={step5Ref} data-step="5" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 5 | Get certified in NETS QR</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After completing your NETS QR ideation and NETS QR coursework, proceed to get certified! Click on 'Get Course Certificate', input the full name to be displayed in the certificate and provide your school email for verification purposes.
            </p>
                <img
                  src={SandboxCourseCertificate}
                  alt="Sandbox Certification 1"
                  className="shadow-md rounded-md w-full max-w-sm cursor-pointer hover:opacity-90 transition-opacity mb-4"
                  onClick={() => openImageModal(SandboxCourseCertificate)}
                />

                <img
                  src={SandboxCourseCertificateDetails}
                  alt="Sandbox Certification 2"
                  className="shadow-md rounded-md w-full max-w-sm cursor-pointer hover:opacity-90 transition-opacity mb-4"
                  onClick={() => openImageModal(SandboxCourseCertificateDetails)}
                />
            
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Choose your certification path based on your project type:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {/* Mobile Certification */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h4 className="font-semibold text-blue-800 mb-3">NETS QR Mobile Certification</h4>
                <p className="text-sm text-blue-700 mb-4">
                  For mobile application projects using NETS QR Mobile integration.
                </p>
                <img
                  src={CertificationTabSandboxNetsQrMobile}
                  alt="NETS QR Mobile Certification"
                  className="shadow-md rounded-md w-full cursor-pointer hover:opacity-90 transition-opacity"
                  onClick={() => openImageModal(CertificationTabSandboxNetsQrMobile)}
                />
              </div>

              {/* Web Certification */}
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <h4 className="font-semibold text-green-800 mb-3">NETS QR Web Certification</h4>
                <p className="text-sm text-green-700 mb-4">
                  For web application projects using NETS QR Web integration.
                </p>
                <img
                  src={CertificationTabSandboxNetsQrWeb}
                  alt="NETS QR Web Certification"
                  className="shadow-md rounded-md w-full cursor-pointer hover:opacity-90 transition-opacity"
                  onClick={() => openImageModal(CertificationTabSandboxNetsQrWeb)}
                />
              </div>
            </div>

            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you've entered your full name and school email, fill in the Transaction ID and the Payment Method Retrieval Reference number based on your chosen NETS QR implementation (Mobile or Web).
            </p>


          </div>

          <div className="mt-6 sm:mt-10 text-left">
            <a 
              href="/competition" 
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-sm sm:text-base font-medium transition duration-300"
            >
              Back to Competition
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NetsQrIdeationLayout;